export const environment = {
  production: false,
  development: true,
  srxBaseUri: 'https://srx.dev.bosch-ridecare.com',
  rccApiUrl: 'https://dev.bosch-ridecare.com',
  deviceConfigS3Bucket: 'rcc-dev-device-config',
  dashboardUrl: 'https://api.dev.bosch-ridecare.com',
  legalUrl: 'https://my.dev.bosch-ridecare.com',
};
